module.exports = __webpack_public_path__ + "img/4.92919603.jpg";